import React, { useState, useEffect, useRef } from "react";

function flytOgRytmeLabelFromFilename(filename) {
  if (!filename) return null;
  const base = String(filename).split("/").pop();
  const m = base.match(/^(\d{2})([ab])\b/i);
  if (!m) return null;
  const num = parseInt(m[1], 10);
  const letter = m[2].toLowerCase();
  console.log(letter, num, "mobile")
  return `${num}${letter}`;
}

function getTabLabel({ tabsData, idx, courseKey }) {
  if (courseKey === "flyt-og-rytme") {
    const l = flytOgRytmeLabelFromFilename(tabsData?.[idx]);
    if (l) return l;
  }
  return String(idx + 1);
}

// Mobile Dropdown Selector Component
const MobileSelector = ({ tabsData, activeTabIndex, onSelectTab, courseKey }) => {
console.log(courseKey, "coursekey")
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  if (!tabsData || tabsData.length <= 1) return null;

  const activeLabel = getTabLabel({ tabsData, idx: activeTabIndex, courseKey });
  console.log(activeLabel, "mobile")
  const handleSelect = (index) => {
    onSelectTab(index);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        className="w-full flex items-center justify-between bg-white/80 backdrop-blur-sm text-gray-700 text-sm px-3 py-2 rounded-lg border border-white/40 hover:bg-white/90 transition-all relative z-20"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-2 min-w-0">
          <span className="font-medium whitespace-nowrap">Select</span>
          <span className="text-gray-500 truncate">
            ({activeLabel}/{tabsData.length})
          </span>
        </div>
        <svg
          className={`w-4 h-4 text-gray-500 transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute w-full mt-1 bg-white/95 backdrop-blur-md rounded-lg shadow-xl border border-white/40 py-2 max-h-60 overflow-y-auto z-70">
          {tabsData.map((_, idx) => {
            const label = getTabLabel({ tabsData, idx, courseKey });
            return (
              <button
                key={idx}
                type="button"
                className={`w-full text-left px-4 py-2 text-sm hover:bg-blue-50/80 transition-colors flex items-center justify-between ${
                  idx === activeTabIndex ? "bg-blue-500/10 text-blue-700 font-medium" : "text-gray-700"
                }`}
                onClick={() => handleSelect(idx)}
              >
                <span className="font-mono">{label}</span>
                {idx === activeTabIndex && (
                  <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MobileSelector;
